import Vue from 'vue'

import { DropdownMenu, DropdownItem, Image, Search } from 'vant'

Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Image)
Vue.use(Search)


// WEBPACK FOOTER //
// ./src/assets/js/utils/vant.js